import React, {useState, useEffect} from "react";
//import queryString from 'query-string';
import io from 'socket.io-client';
import {FaArrowRight} from 'react-icons/fa';
import {AiFillHome} from 'react-icons/ai';
//import {getFromStorage, setInStorage} from "../utils/storage";

//import '../Chat/Chat.css';
import '../App.css';
//import TextContainer from '../Chat/TextContainer/TextContainer';
import InfoBar from "../Chat/InfoBar/InfoBar";
import Input from "../Chat/Input/Input";
import Messages from "../Chat/Messages/Messages";
import WebRTC from "../Chat/WebRTC/WebRTC";
import {ENDPOINT} from '../utils/Constants.js';

let socket;

const VideoChat = (props) =>{
    let {userName, role, group} = props.userInfo;
    const [name] = useState(userName+"_"+group);
    const [room] = useState("Text Chat");
    //const [users, setUsers] = useState('');
    const [message, setMessage] = useState([]);
    const [messages, setMessages] = useState([]);
    const [endCall,setEndCall] = useState(false);


    useEffect(()=>{
      console.log(name, room);
      socket = io(ENDPOINT);
      socket.emit('join', {name, room}, (error)=>{
          if(error) {
              alert(error);
          }
      });

      socket.on('message', (message)=>{
          setMessages(messages =>[...messages, message]);
      })

  /*    socket.on("roomData", ({users}) =>{
          setUsers(users)
      });
*/
}, [name,room]);

    //function for sending messages
    const sendMessage = (event) => {

        event.preventDefault();
        if(message) {
           socket.emit('sendMessage', message, ()=>setMessage(''));
         }
    }
    function onLeave(){
      console.log("Leaving Chat...");
      setEndCall(true)
      socket.disconnect(true)
    }

  console.log("Message:",message, messages);
  return(
    <div>
      <div className="outerContainer">
          <div className="webrtc">
              <WebRTC
                name = {name}
                room="VideoCall"
                role={role}
                leave={endCall}
                onLeave={props.onChange}
                nextPage = {props.nextPage}
              />
          </div>
          <div className="message">
              <InfoBar room={room} />
              <Messages messages={messages} name={name}/>
              <Input message={message} setMessage={setMessage} sendMessage={sendMessage}/>
          </div>
      </div>
      {role===1?
      <button className="surveyButton blue flexButton" onClick={onLeave}><AiFillHome/></button>
      :<button className="textButton blue flexButton" onClick={onLeave}>Next <FaArrowRight className="iconR"/></button>
      }
    </div>
  )
}

export default VideoChat;
